import {Component, OnDestroy, OnInit} from '@angular/core';

import {LocalStorageService} from '../../services/local-storage.service';
import {NotificationsService} from '../../services/notifications/notifications.service';
import {Subscription, timer} from 'rxjs';
import {MessageCount} from '../../domains/common.domain';
import {ErrorService} from '../../services/error/error.service';
import {switchMap} from 'rxjs/operators';
import {EnvironmentService} from '../../services/environment.service';

@Component({
  selector: 'app-notifications',
  styleUrls: ['./notifications.component.scss'],
  templateUrl: './notifications.component.html',
})

export class NotificationsComponent implements OnInit, OnDestroy {
  activateBell: boolean;
  notificationCount: number;
  role: string;
  technicianId: string;
  notificationCount$: Subscription;

  constructor(
    private environmentService: EnvironmentService,
    private errorService: ErrorService,
    private localStorageService: LocalStorageService,
    private notificationsService: NotificationsService,
  ) {
  }

  ngOnInit(): void {
    this.notificationCount = 0;
    this.technicianId = this.localStorageService.getItem('technician_id');
    this.role = this.localStorageService.getItem('role');
    this.activateBell = true; // this.technicianId && this.role === 'employee';

    if (this.activateBell) {
      this.notificationCount$ = timer(1000, this.environmentService.notificationDelayTime).pipe(
        switchMap(() => this.notificationsService.getNotificationCount())
      ).subscribe((response: MessageCount) => {
        this.errorService.throwErrorIfFailure(response, false);
        this.notificationCount = Number(response.message[0].count);
      }, error => {
        this.errorService.throwErrorIfFailure(error, false);
      });
    }
  }

  ngOnDestroy(): void {
    this.activateBell = false;
    this.notificationCount = 0;
    this.notificationCount$.unsubscribe();
  }

  viewNotifications(): void {
    if (this.activateBell) {
      this.notificationsService.notifyOnViewNotification();
    }
  }
}
